import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import App from "../app/index";

const { appConfig } = window.asos.mastercard.state;
delete window.asos.mastercard.state;

const start = async () => {
  loadableReady(() => {
    hydrateRoot(
      document.getElementById("react-root"),
      <App appConfig={appConfig} />
    );
  });
};

start();
